import React, { useState } from "react";
import Login from "../Login";
import Signup from "../Signup";

function AuthModal({
  authState,
  onClose,
  onLoginSuccess,
  onSignupSuccess,
  onSwitchToLogin,
  onSwitchToSignup,
}) {
  const isLogin = authState === "login";
  const [isClosing, setIsClosing] = useState(false);
  const requestClose = () => {
    if (isClosing) return;
    setIsClosing(true);
    window.setTimeout(onClose, 220);
  };

  return (
    <div
      className={`auth-modal-overlay${isClosing ? " is-closing" : ""}`}
      onClick={(event) => event.target === event.currentTarget && requestClose()}
    >
      <div className="auth-modal">
        <div className="auth-modal-header">
          <div className="auth-modal-brand">
            <span>KANSASROOT</span>
            <small>Your Partner in Success</small>
          </div>
          <p className="auth-modal-eyebrow">
            {isLogin ? "Welcome Back" : "Create Account"}
          </p>
          <h2>{isLogin ? "Login to Kansasroot" : "Sign Up"}</h2>
          <button
            onClick={requestClose}
            className="auth-modal-close"
            type="button"
            aria-label="Close authentication dialog"
          >
            &times;
          </button>
        </div>
        <div className="auth-modal-content">
          {isLogin ? (
            <Login
              onLoginSuccess={onLoginSuccess}
              onSwitchToSignup={onSwitchToSignup}
            />
          ) : (
            <Signup
              onSignupSuccess={onSignupSuccess}
              onSwitchToLogin={onSwitchToLogin}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default AuthModal;
